import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./ForgotPasswordModal.css";
// import forgotVc from "../../Assets/Images/images.jpeg";
import { postData } from "../../Services/Api";
import { toast } from "react-toastify";

export default function ForgotPasswordModal({
  show,
  handleClose,
  handleSignUp,
}) {
  const [showForgotPassword, setShowForgotPassword] = useState(true);
  const [showCheckEmail, setShowCheckEmail] = useState(false);
  const [showPasswordChange, setShowPasswordChange] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [mailMessage, setMailMessage] = useState("");
  const [isShowNextBtn, setIsShowNextBtn] = useState(false);
  const [token, setToken] = useState("");

  const handleForgotPasswordClose = () => {
    // setShowForgotPassword(false);
    // setShowCheckEmail(false);
    // setShowPasswordChange(false);
    handleClose();
  };

  const handleResetPassword = async () => {
    try {
      // Make a POST request to reset password
      const data = {
        email: email,
      };
      const postDataResponse = await postData("auth/forgot-password", data);
      if (postDataResponse.success) {
        const { is_mail_sent } = postDataResponse.data;
        if (is_mail_sent) {
          setIsShowNextBtn(true);
          setShowForgotPassword(false);
          setShowCheckEmail(true);
        }
        setMailMessage(postDataResponse?.data?.message);
      } else {
        setMailMessage(postDataResponse?.message);
      }
    } catch (error) {
      // setMailMessage(error?.message);
      // console.error("Error resetting password:", error);
    }
    // Here you can add your logic to reset the password

    // After resetting the password, toggle to show the "Check Your Email" section
    // setShowForgotPassword(false);
    // setShowCheckEmail(true);
  };

  const handleNext = () => {
    setShowCheckEmail(false);
    setShowPasswordChange(true);
  };

  const handleChangePassword = async () => {
    const data = {
      email: email,
      password: newPassword,
      password_confirmation: confirmPassword,
      pw_token: token,
    };
    const postDataResponse = await postData(
      "auth/forgot-password-submit",
      data
    );
    if (postDataResponse.success) {
      toast.success(postDataResponse?.data?.message);
      handleForgotPasswordClose();
    } else {
      // setMailMessage(postDataResponse?.message);
      toast.error(postDataResponse?.message);
    }
  };

  return (
    <div className="">
      <Modal
        className="shadow-lg"
        show={show}
        onHide={handleForgotPasswordClose}
        centered
        size="xl"
      >
        <div className="position-absolute start-0 top-0 p-5 z-n1 greenOval rounded-circle"></div>
        <div className="container-fluid shadow-lg">
          <div className="row no-gutter">
            <div className="col-md-6 bg-white rounded-start-5">
              <div className="login py-5">
                <div className="card border-0 w-100 px-2 ps0 pe0">
                  <div className="card-title text-center ">
                    {/* <img src={forgotVc} className='forgotVc img-fluid' alt="dj" /> */}
                    {showForgotPassword && (
                      <h3 className="p-3 pb-1">Forgot Password</h3>
                    )}
                    {showCheckEmail && isShowNextBtn && (
                      <h3 className="p-3 pb-1">Check Your Email</h3>
                    )}
                    {showPasswordChange && (
                      <h3 className="p-3 pb-1">Change Password</h3>
                    )}
                    <small className="text-secondary">
                      {showForgotPassword &&
                        "To reset your password, you need your email or mobile number that can be authenticated"}
                      {showCheckEmail && (
                        <div>
                          <p>{mailMessage}</p>
                          {/* <p>Your pw_token is: {pwToken}</p> */}
                        </div>
                      )}
                      {showPasswordChange &&
                        "Enter your new password and confirm it."}
                    </small>
                  </div>
                  <div className="card-body">
                    <form>
                      {showForgotPassword && (
                        <div className="mb-4">
                          <label htmlFor="username" className="form-label">
                            Email*
                          </label>
                          <input
                            type="email"
                            className="form-control customFormText px-3 py-2 rounded-5"
                            placeholder="Email"
                            id="username"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <div className="text-danger">{mailMessage}</div>
                        </div>
                      )}
                      {showPasswordChange && (
                        <div>
                          <div className="mb-4">
                            <label htmlFor="token" className="form-label">
                              Token *
                            </label>
                            <input
                              type="token"
                              className="form-control customFormText px-3 py-2 rounded-5"
                              placeholder="Token"
                              id="token"
                              value={token}
                              onChange={(e) => setToken(e.target.value)}
                              autoComplete="off"
                            />
                          </div>
                          <div className="mb-4">
                            <label htmlFor="newPassword" className="form-label">
                              New Password*
                            </label>
                            <input
                              type="password"
                              className="form-control customFormText px-3 py-2 rounded-5"
                              placeholder="New Password"
                              id="newPassword"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                            />
                          </div>
                          <div className="mb-4">
                            <label
                              htmlFor="confirmPassword"
                              className="form-label"
                            >
                              Confirm Password*
                            </label>
                            <input
                              type="password"
                              className="form-control customFormText px-3 py-2 rounded-5"
                              placeholder="Confirm Password"
                              id="confirmPassword"
                              value={confirmPassword}
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      )}
                      <div className="d-grid mt-5">
                        {showForgotPassword && (
                          <Button
                            onClick={handleResetPassword}
                            className="btn btn-default startedBtn rounded-5 pt-2 pb-2 fs-5 px-4"
                          >
                            Reset Password
                          </Button>
                        )}
                        {showCheckEmail && isShowNextBtn && (
                          <Button
                            onClick={handleNext}
                            className="btn btn-default startedBtn rounded-5 pt-2 pb-2 fs-5 px-4"
                          >
                            Next
                          </Button>
                        )}
                        {showPasswordChange && (
                          <Button
                            onClick={handleChangePassword}
                            className="btn btn-default startedBtn rounded-5 pt-2 pb-2 fs-5 px-4"
                          >
                            Change Password
                          </Button>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 rounded-end-2 d-none d-md-flex bg-image"></div>
          </div>
        </div>
        <div className="position-absolute p-5 bottom-0 end-0 z-n1 redOval rounded-circle"></div>
      </Modal>
    </div>
  );
}
